import React from 'react';
import MenuBackend from './backend/MenuBackend'
import Menufrontend from './frontend/MenuFrontend'
import { useLocation } from "react-router-dom";


export default function PrimarySearchAppBar({ institution, frontendColor, refresh, language, setLanguage}) {
    const location = useLocation();

    return (
        (location.pathname.includes("/backend/")) ?
            <MenuBackend/>
            :
            location.pathname.includes("/mediaserver/") ?
                null
                :
            <Menufrontend institution={institution} frontendColor={frontendColor} refresh={refresh} language={language} setLanguage={setLanguage} />
    );
}
